export default __webpack_public_path__ + "static/media/donut.c5a819b0.png";